(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    if (!window.__piqLocalizationCountryLanguageSync) {
    window.__piqLocalizationCountryLanguageSync = true;

    const applyPreferredLanguage = (item) => {
      if (!(item instanceof HTMLElement)) return;

      const component = item.closest('localization-form-component');
      const form = component?.querySelector('form');
      const languageCode = item.dataset.languageCode;

      if (!(form instanceof HTMLFormElement) || !languageCode) return;

      let languageInput = form.querySelector('input[data-preferred-language-sync]');

      if (!(languageInput instanceof HTMLInputElement)) {
        languageInput = document.createElement('input');
        languageInput.type = 'hidden';
        languageInput.name = 'language_code';
        languageInput.dataset.preferredLanguageSync = 'true';
        form.append(languageInput);
      }

      languageInput.value = languageCode;
    };

    document.addEventListener(
      'click',
      (event) => {
        const item =
          event.target instanceof Element
            ? event.target.closest('.localization-form__list-item[data-language-code]')
            : null;
        applyPreferredLanguage(item);
      },
      true
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Enter') return;

        const item =
          document.activeElement instanceof Element
            ? document.activeElement.closest('.localization-form__list-item[data-language-code]')
            : null;
        applyPreferredLanguage(item);
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
